export class ReorderableGroupMap {
    constructor() {
        this._map = new WeakMap();
    }
    add(repeater) {
        const { repeaterId, items } = repeater;
        this._map.set(items, { group: () => repeater.type, repeaterId });
    }
    remove(repeater) {
        const { items } = repeater;
        this._map.delete(items);
    }
    get(items) {
        return this._map.get(items);
    }
}

//# sourceMappingURL=reorderable-group-map.js.map
